import { RiskLevelEnum } from '@authority-labs/enums';
import { RiskLevelDto } from '../risk-level.dto';
import { InspectionCase } from './inspection-case.dto';

export class InspectionRiskLevelsCaseDto extends InspectionCase {
  riskLevels?: RiskLevelDto[];
}

export class InspectionRiskLevelsCase extends InspectionRiskLevelsCaseDto {
  constructor(data: InspectionRiskLevelsCaseDto = {}) {
    super(data);
    this.riskLevels = data.riskLevels || [
      { level: RiskLevelEnum.Easy },
      { level: RiskLevelEnum.Regular1 },
      { level: RiskLevelEnum.Regular2 },
      { level: RiskLevelEnum.High1 },
      { level: RiskLevelEnum.High2 },
      { level: RiskLevelEnum.SpecialRisk },
      { level: RiskLevelEnum.Storage }
    ];
  }
}
